import { useEffect, useState, type RefObject } from 'react';
import { disabledEngine, loadModerationEngine } from '../moderation/engine.ts';

const CHECK_EVERY_MS = 2_000;

/**
 * Prüft das eingehende Video regelmäßig lokal (siehe moderation/engine.ts) und sagt, ob es
 * unscharf gezeigt werden soll. Der Zustand gilt pro Stream – ein neues Match startet sauber.
 */
export function useRemoteModeration(
  videoRef: RefObject<HTMLVideoElement | null>,
  stream: MediaStream | null,
) {
  const [flagged, setFlagged] = useState<MediaStream | null>(null);
  const [revealed, setRevealed] = useState<MediaStream | null>(null);

  useEffect(() => {
    if (!stream) return;
    let cancelled = false;
    let timer: number | undefined;

    void loadModerationEngine().then((engine) => {
      if (cancelled || engine === disabledEngine) return;
      const check = async () => {
        const video = videoRef.current;
        if (video && video.readyState >= HTMLMediaElement.HAVE_CURRENT_DATA) {
          const verdict = await engine.classify(video);
          if (!cancelled && verdict.unsafe) setFlagged(stream);
        }
        if (!cancelled) timer = window.setTimeout(check, CHECK_EVERY_MS);
      };
      void check();
    });

    return () => {
      cancelled = true;
      window.clearTimeout(timer);
    };
  }, [stream, videoRef]);

  return {
    blurred: stream !== null && flagged === stream && revealed !== stream,
    reveal: () => setRevealed(stream),
  };
}
